import React from "react";
import * as Icons from "lucide-react";
import { SOLUTIONS, IMAGES } from "../mock";
import Reveal from "./Reveal";

const SolutionsSection = () => (
  <section className="py-16 sm:py-20 bg-white relative">
    <div
      className="absolute inset-0 opacity-[0.03]"
      style={{ backgroundImage: `url(${IMAGES.facility}?w=1400&q=60)`, backgroundSize: "cover", backgroundPosition: "center" }}
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
      <Reveal className="text-center mb-12 max-w-2xl mx-auto">
        <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">Our Solutions</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-navy font-head mt-2">One Stop Solution for Laundry &amp; Dry Clean</h2>
        <p className="text-navy/60 mt-3">From pickup to delivery — professional cleaning, eco-friendly products and guaranteed satisfaction at every step.</p>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SOLUTIONS.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Sparkles;
          return (
            <Reveal key={s.title} delay={i * 60}>
              <div className="group bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all h-full">
                <span className="w-12 h-12 inline-flex items-center justify-center rounded-xl bg-navy group-hover:bg-orange-brand text-white transition-colors mb-4">
                  <Icon size={24} />
                </span>
                <h3 className="font-semibold text-lg text-navy font-head">{s.title}</h3>
                <p className="text-sm text-navy/60 mt-2 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default SolutionsSection;
